// Cableado React de la renovacion de sesion (renewal.ts). Mudado desde
// apps/tower/src/auth/useRenewal.ts. Es el unico lugar que arranca el
// temporizador: vive en la raiz de la SPA, donde esta el estado de la
// sesion, y muere con ella. La logica no esta aca: aca solo se ata el ciclo
// de vida del componente al de la renovacion.
//
// El hook se construye a partir del `Renewal` de la SPA (cada una tiene su
// store y su pool), porque un hook no puede recibir la instancia por
// parametro sin cambiarle la firma a todos los que ya lo usan.
import { useEffect } from "react";
/**
 * Arma el hook que mantiene viva la sesion mientras el componente este
 * montado.
 *
 * `onRenovada` y `onLogout` tienen que ser estables (useCallback o el setter
 * de useState): si cambian de identidad en cada render, el efecto se rearma
 * y el temporizador nunca llega a disparar.
 *
 * `deps` es solo para tests; en produccion se omite (mismo motivo: un objeto
 * literal nuevo por render rearmaria el efecto).
 */
export function createSessionRenewalHook(renewal) {
    return function useRenovacionDeSesion(session, onRenovada, onLogout, deps) {
        useEffect(() => {
            if (session === null)
                return;
            // El spread condicional y no `deps: deps`: con exactOptionalPropertyTypes
            // pasar la propiedad en undefined no es lo mismo que no pasarla.
            return renewal.iniciarRenovacionAutomatica({
                session,
                onRenovada,
                onLogout,
                ...(deps === undefined ? {} : { deps }),
            });
        }, [session, onRenovada, onLogout, deps]);
    };
}
//# sourceMappingURL=useRenewal.js.map